// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModuleUI_wrapper__tCX30","content":"ModuleUI_content__Ijb7m","overlay":"ModuleUI_overlay__6QVHi"};